import {useRouter} from 'next/router';
import {twMerge} from 'tailwind-merge';
import {AskIsLoginChecker} from '../../../common/checkers/AskIsLoginChecker';
import {IsLoginChecker} from '../../../common/checkers/IsLoginChecker';
import {t} from '../../../common/getTranslations';
import {requestContext} from '../../../common/requestContext';
import {TabPositionControl} from '../../../design-system/atoms/TabPositionControl/TabPositionControl';
import {HeaderTitle} from '../../../design-system/organisms/HeaderTitle/HeaderTitle';
import {MainTab} from '../../../design-system/organisms/MainTab/MainTab';
import {useLogin} from '../../../user/useLogin.hook';
import {ASK_TAB_ITEMS, AskTabType, AskType} from '../constant';
import {AskMy} from '../presentational/AskMy';
import {AskRequest} from '../presentational/AskRequest';
import {AskMyContainer} from './AskMyContainer';
import {AskRequestContainer} from './AskRequestContainer';

export function AskPageContainer() {
  const {isMobile, isWebView} = requestContext.requestInfo.display;
  const {isLogin} = useLogin();

  const router = useRouter();

  const currentTabType =
    router.query?.tab === AskTabType.My ? AskTabType.My : AskTabType.Request;

  const askType = router.query?.askType as AskType;

  return (
    <div className="flex grow flex-col text-theme-solid-100">
      <TabPositionControl depth={1} isMobile={isMobile} isWebView={isWebView}>
        {isLogin && (
          <MainTab
            showBorder
            isMobile={isMobile}
            title={t('more_customer_cs_tab')}
            currentTabItemId={currentTabType}
            tabItems={ASK_TAB_ITEMS}
            className={twMerge(
              !isMobile && 'mt-0 pt-20pxr px-15pxr bg-theme-bg-base'
            )}
          />
        )}
        {!isLogin && !isMobile && (
          <HeaderTitle className="px-15pxr mb-32pxr bg-theme-bg-base w-full">
            {t('more_customer_cs_tab')}
          </HeaderTitle>
        )}
      </TabPositionControl>

      {currentTabType === AskTabType.Request && (
        <AskIsLoginChecker>
          <AskRequestContainer initialAskType={askType}>
            {props => <AskRequest {...props} />}
          </AskRequestContainer>
        </AskIsLoginChecker>
      )}
      {currentTabType === AskTabType.My && (
        <IsLoginChecker>
          <AskMyContainer>{props => <AskMy {...props} />}</AskMyContainer>
        </IsLoginChecker>
      )}
    </div>
  );
}
